module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-upgrade-359d632b0273c41214d979a6de1682fc.png";